import type { Theme } from "@/types/config/theme";

export function applyTheme(theme: Theme): void {
  const id = "theme";
  const existingTheme = document.getElementById(id);

  if (existingTheme) {
    existingTheme.remove();
  }

  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = `./themes/${theme}.css`;
  link.id = id;

  document.head.appendChild(link);
}
